import avatar from "../assets/icon.jpg";

export const testimonials = [
  {
    name: "John Kamotho",
    role: "CEO, TYPO JSC",
    avatar,
    quote:
      "We have been using this logistics company for our shipping needs, and they have exceeded our expectations. The team is dedicated, and they handle our packages with care. Their services have been instrumental in our business success.",
  },
  {
    name: "Mark Mwangi",
    role: "CEO, OFFS",
    avatar,
    quote:
      "I am extremely satisfied with the logistics services provided by this company. They have been prompt, reliable, and efficient in delivering our goods. The entire team is professional and courteous.",
  },
  {
    name: "Simon Konecki",
    role: "CEO, LOGISTICS INC",
    avatar,
    quote:
      "I have been using the logistics services of this company for several years now, and they have been consistently excellent. They handle all our shipments with precision and deliver on time. Their customer support is top-notch.",
  },
];
